// SEO landing pages — Portuguese (PT-PT) only for SEO content.
// Each page has a `lite` block with EN + DE overrides for international visitors
// (hero title/subtitle, top 3 benefits, CTA labels). FAQs, process and long-form
// text remain in PT-PT to avoid duplicate content issues and translation errors.
const COMMON_BENEFITS_NOTE = "Mais de 20 anos a tratar pacientes em Portimão e em todo o Barlavento Algarvio.";

const LITE_LABELS = {
  en: {
    bannerLabel: "This page is also available in:",
    ctaPrimary: "Book Evaluation",
    ctaWhatsApp: "WhatsApp",
    noteFallback: "Over 20 years caring for patients in Portimão and the Western Algarve.",
  },
  de: {
    bannerLabel: "Diese Seite ist auch verfügbar in:",
    ctaPrimary: "Termin vereinbaren",
    ctaWhatsApp: "WhatsApp",
    noteFallback: "Über 20 Jahre Erfahrung in der Betreuung von Patienten in Portimão und an der westlichen Algarve.",
  },
};

export const LITE_AVAILABLE = ["en", "de"];
export { LITE_LABELS };

export const SERVICE_LANDING = {
  implantes: {
    slug: "implantes-dentarios-portimao",
    seoTitle: "Implantes Dentários em Portimão | Instituto Clínico do Barlavento",
    seoDescription:
      "Implantes dentários em Portimão com cirurgia guiada por IA, planeamento 3D e mais de 20 anos de experiência. Recupere o seu sorriso com segurança. Marque já a sua consulta.",
    keyword: "Implantes Dentários",
    h1: "Implantes Dentários em Portimão",
    hero: {
      eyebrow: "Solução Definitiva",
      subtitle:
        "Recupere os seus dentes com uma solução fixa, estética e duradoura. Cirurgia guiada por Inteligência Artificial no centro de Portimão, com mais de 20 anos de experiência ao serviço do Barlavento Algarvio.",
      image: "https://customer-assets.emergentagent.com/job_barlavento-dental/artifacts/ys02gdc3_download%20%281%29.png",
    },
    intro: {
      title: "O que são implantes dentários?",
      body:
        "Os implantes dentários são raízes artificiais em titânio biocompatível, colocadas no osso maxilar para substituir dentes perdidos. Sobre o implante é fixada uma coroa, ponte ou prótese, devolvendo função e estética idênticas a um dente natural. No Instituto Clínico do Barlavento utilizamos tecnologia 3D e cirurgia guiada por IA para garantir o máximo de precisão, conforto e previsibilidade.",
    },
    benefits: [
      { icon: "Anchor", title: "Solução fixa e duradoura", desc: "Os implantes dentários integram-se no osso e podem durar décadas com os cuidados adequados." },
      { icon: "Smile", title: "Estética natural", desc: "Coroas em cerâmica desenhadas digitalmente para se confundirem com os seus dentes naturais." },
      { icon: "Brain", title: "Cirurgia guiada com IA", desc: "Planeamento 3D assistido por Inteligência Artificial — menos tempo de cirurgia e máxima precisão." },
      { icon: "ShieldCheck", title: "Sem afetar dentes vizinhos", desc: "Ao contrário de pontes, o implante não exige desgastar dentes saudáveis adjacentes." },
    ],
    process: [
      { title: "Avaliação Inicial", desc: "Diagnóstico clínico, TAC 3D e plano de tratamento personalizado com estimativa de custos." },
      { title: "Planeamento Digital", desc: "Simulação 3D da cirurgia assistida por IA para definir a posição ideal do implante." },
      { title: "Colocação do Implante", desc: "Cirurgia minimamente invasiva, em ambiente controlado, com anestesia local." },
      { title: "Osteointegração", desc: "Período de cicatrização (2-4 meses) em que o implante se funde com o osso." },
      { title: "Colocação da Coroa", desc: "Coroa definitiva em cerâmica, fabricada por CAD/CAM para um ajuste perfeito." },
    ],
    why: [
      { title: "Tecnologia 3D e IA", desc: "Cirurgia guiada com Inteligência Artificial — única no Algarve." },
      { title: "Equipa multidisciplinar", desc: "Cirurgião e prostodontista em estreita colaboração com técnicos de laboratório altamente especializados." },
      { title: "Garantia e acompanhamento", desc: "Controlos clínicos regulares e plano de manutenção personalizado." },
    ],
    faq: [
      {
        q: "Os implantes dentários doem?",
        a: "A colocação do implante é feita com anestesia local — é um procedimento confortável e indolor. O pós-operatório é geralmente bem tolerado, com desconforto ligeiro nos primeiros dias, gerido com medicação simples.",
      },
      {
        q: "Quanto tempo demora todo o tratamento?",
        a: "Entre a colocação do implante e a coroa definitiva passam normalmente 2 a 4 meses, tempo necessário à osteointegração. Em casos selecionados é possível carga imediata (dentes no mesmo dia).",
      },
      {
        q: "Quanto custam os implantes dentários em Portimão?",
        a: "O custo depende do número de implantes, tipo de coroa e da necessidade de enxerto ósseo. Na primeira consulta apresentamos uma estimativa detalhada e discutimos soluções de pagamento adequadas, incluindo opções de financiamento através de entidades parceiras.",
      },
    ],
    note: COMMON_BENEFITS_NOTE,
    lite: {
      en: {
        h1: "Fixed Dental Implants in Portimão",
        subtitle: "Restore your smile and confidence with precision 3D implants. High-quality care by experienced dentists in the heart of Algarve.",
        benefits: [
          { icon: "Anchor", title: "Fixed and long-lasting", desc: "Implants integrate with the bone and can last decades with proper care." },
          { icon: "Smile", title: "Natural aesthetics", desc: "Digitally designed ceramic crowns that blend seamlessly with your natural teeth." },
          { icon: "Brain", title: "AI-guided surgery", desc: "3D planning assisted by Artificial Intelligence — shorter surgery time, maximum precision." },
        ],
      },
      de: {
        h1: "Zahnimplantate in Portimão",
        subtitle: "Schenken Sie sich ein neues Lächeln mit festsitzendem Zahnersatz. Präzise 3D-Implantologie und langjährige Erfahrung im Zentrum von Portimão.",
        benefits: [
          { icon: "Anchor", title: "Fest und langlebig", desc: "Implantate verbinden sich mit dem Knochen und können bei guter Pflege Jahrzehnte halten." },
          { icon: "Smile", title: "Natürliche Ästhetik", desc: "Digital designte Keramikkronen, die sich nahtlos in Ihre natürlichen Zähne einfügen." },
          { icon: "Brain", title: "KI-gestützte Chirurgie", desc: "3D-Planung unterstützt durch Künstliche Intelligenz — kürzere OP-Zeit, höchste Präzision." },
        ],
      },
    },
  },

  alinhadores: {
    slug: "alinhadores-invisiveis-portimao",
    seoTitle: "Alinhadores Invisíveis em Portimão (Invisalign & Spark) | Instituto Clínico do Barlavento",
    seoDescription:
      "Alinhadores invisíveis em Portimão com Invisalign e Spark — corrija os seus dentes de forma estética, confortável e discreta. Diagnóstico digital com IA. Marque a sua consulta.",
    keyword: "Alinhadores Invisíveis",
    h1: "Alinhadores Invisíveis em Portimão",
    hero: {
      eyebrow: "Invisalign & Spark",
      subtitle:
        "Corrija o seu sorriso de forma quase invisível, sem fios nem brackets. Tecnologias líderes mundiais — Invisalign e Spark — com diagnóstico digital em Portimão. A discrição e o conforto que sempre quis.",
      image: "https://customer-assets.emergentagent.com/job_barlavento-dental/artifacts/ys02gdc3_download%20%281%29.png",
    },
    intro: {
      title: "O que são alinhadores invisíveis?",
      body:
        "Os alinhadores invisíveis são pequenas placas transparentes, personalizadas e removíveis, que substituem os tradicionais aparelhos fixos. Cada conjunto move os dentes progressivamente até à posição final planeada. No Instituto Clínico do Barlavento trabalhamos com as duas marcas líderes a nível mundial — Invisalign e Spark — adaptando a escolha ao caso clínico de cada paciente.",
    },
    benefits: [
      { icon: "Eye", title: "Praticamente invisíveis", desc: "Quase impercetíveis no dia a dia — sem comprometer a sua imagem profissional ou social." },
      { icon: "Smile", title: "Confortáveis", desc: "Sem fios nem brackets a magoar a boca. Material macio, ajustado ao milímetro." },
      { icon: "Utensils", title: "Removíveis", desc: "Retire para comer, beber e escovar os dentes. Higiene oral mantida sem dificuldade." },
      { icon: "ScanLine", title: "Resultado previsível", desc: "Simulação 3D antes de começar — vê o seu sorriso final antes do primeiro alinhador." },
    ],
    process: [
      { title: "Consulta e Diagnóstico", desc: "Avaliação clínica, scanner intraoral digital e simulação 3D do resultado final." },
      { title: "Plano Personalizado", desc: "Definição do número de alinhadores e duração estimada do tratamento." },
      { title: "Início do Tratamento", desc: "Entrega dos primeiros alinhadores e instruções de utilização (20-22h/dia)." },
      { title: "Acompanhamento", desc: "Consultas regulares (4-8 semanas) para troca dos alinhadores e verificação." },
      { title: "Manutenção do Sorriso", desc: "Após o tratamento, contenção fixa ou removível para manter os resultados." },
    ],
    why: [
      { title: "Invisalign e Spark certificados", desc: "Trabalhamos com as duas marcas líderes — escolhemos a melhor para o seu caso." },
      { title: "Diagnóstico digital com IA", desc: "Scanner intraoral e planeamento 3D assistido por Inteligência Artificial." },
      { title: "Acompanhamento próximo", desc: "Equipa estável e disponível para esclarecer qualquer dúvida ao longo do tratamento." },
    ],
    faq: [
      {
        q: "Quanto tempo demora um tratamento com alinhadores?",
        a: "Em média 6 a 18 meses, dependendo da complexidade do caso. Casos ligeiros podem estar concluídos em 4-6 meses; casos mais complexos podem demorar 18-24 meses.",
      },
      {
        q: "Os alinhadores invisíveis doem?",
        a: "É normal sentir alguma pressão nos primeiros dias de cada novo alinhador — é sinal de que estão a funcionar. Não há fios nem brackets a magoar a boca, ao contrário dos aparelhos tradicionais.",
      },
      {
        q: "Posso comer com os alinhadores postos?",
        a: "Não — os alinhadores são removidos para comer e beber qualquer coisa exceto água. Isto evita pigmentações e prolonga a vida útil do alinhador. Devem ser usados 20 a 22 horas por dia.",
      },
    ],
    note: COMMON_BENEFITS_NOTE,
    lite: {
      en: {
        h1: "Invisible Aligners in Portimão (Invisalign & Spark)",
        subtitle: "Straighten your teeth discreetly and comfortably with world-leading clear aligners. Digital planning and AI diagnostics in the heart of Portimão.",
        benefits: [
          { icon: "Eye", title: "Virtually invisible", desc: "Almost imperceptible in daily life — your professional and social image stays intact." },
          { icon: "Smile", title: "Comfortable", desc: "No wires or brackets to hurt your mouth. Soft material with a millimetre-precise fit." },
          { icon: "Utensils", title: "Removable", desc: "Take them off to eat, drink and brush. Oral hygiene stays simple from day one." },
        ],
      },
      de: {
        h1: "Unsichtbare Zahnschienen in Portimão (Invisalign & Spark)",
        subtitle: "Begradigen Sie Ihre Zähne diskret und komfortabel mit den weltweit führenden Aligner-Technologien. Digitale Planung und KI-Diagnostik im Zentrum von Portimão.",
        benefits: [
          { icon: "Eye", title: "Nahezu unsichtbar", desc: "Im Alltag kaum wahrnehmbar — Ihr berufliches und soziales Erscheinungsbild bleibt unverändert." },
          { icon: "Smile", title: "Komfortabel", desc: "Keine Drähte oder Brackets, die wehtun. Weiches Material in millimetergenauer Passform." },
          { icon: "Utensils", title: "Herausnehmbar", desc: "Zum Essen, Trinken und Zähneputzen einfach abnehmen. Mundhygiene bleibt unkompliziert." },
        ],
      },
    },
  },

  ortodontia: {
    slug: "ortodontia-portimao",
    seoTitle: "Ortodontia Especializada em Portimão | ATM, Condilografia e Articuladores — Instituto Clínico do Barlavento",
    seoDescription:
      "Ortodontia especializada em Portimão com foco na articulação temporomandibular (ATM), postura e diagnóstico funcional avançado com radiologia digital assistida por IA. Tratamento para crianças, jovens e adultos.",
    keyword: "Ortodontia Especializada",
    h1: "Ortodontia Especializada em Portimão",
    hero: {
      eyebrow: "ATM · Diagnóstico Funcional · Postura",
      subtitle:
        "Ortodontia funcional, estética e postural em Portimão. Diagnóstico avançado da articulação temporomandibular (ATM), planeamento com radiologia digital assistida por Inteligência Artificial e abordagem multidisciplinar — para crianças, jovens e adultos.",
      image: "https://customer-assets.emergentagent.com/job_barlavento-dental/artifacts/ys02gdc3_download%20%281%29.png",
    },
    intro: {
      title: "Ortodontia funcional e postural — o que nos torna únicos",
      body:
        "A maioria das clínicas trata os dentes. Nós tratamos o sorriso, a articulação dos maxilares (ATM) e a postura como um todo. Utilizamos articuladores especializados e radiologia digital assistida por Inteligência Artificial para registar com precisão a função articular, planeando tratamentos ortodônticos que respeitam a biomecânica real de cada paciente. O resultado: dentes alinhados, mastigação eficiente, menos dores de cabeça e melhor postura — para crianças, jovens e adultos.",
    },
    benefits: [
      { icon: "Smile", title: "Sorriso harmonioso", desc: "Dentes alinhados e estética facial melhorada, com autoconfiança redobrada." },
      { icon: "Activity", title: "Função articular protegida", desc: "Planeamento guiado pela ATM — menos desgaste, menos dor, menos disfunção." },
      { icon: "Compass", title: "Postura corrigida", desc: "A oclusão correta tem impacto direto na postura cervical e na qualidade de vida." },
      { icon: "Users", title: "Para todas as idades", desc: "Diagnóstico precoce possível assim que a idade e colaboração do paciente o permitam. Tratamento eficaz também em adultos." },
    ],
    process: [
      { title: "Consulta Ortodôntica", desc: "Avaliação clínica, fotografias, radiografias e exame da articulação dos maxilares." },
      { title: "Condilografia e Articulador", desc: "Quando indicado, registo digital do movimento da mandíbula em articulador especializado para análise precisa da função articular." },
      { title: "Estudo Craneomandibular", desc: "Estudo completo com recurso a scanners digitais, ferramentas de análise funcional e radiologia digital assistida por Inteligência Artificial." },
      { title: "Escolha do Aparelho", desc: "Aparelho fixo (metálico ou estético) adequado ao seu caso clínico." },
      { title: "Tratamento e Contenção", desc: "Acompanhamento clínico regular durante o tratamento e fase de contenção individualizada para manutenção dos resultados." },
    ],
    why: [
      { title: "Diagnóstico funcional avançado", desc: "Utilizamos condilografia digital sempre que necessário para análise precisa da articulação temporomandibular — uma das poucas clínicas em Portugal." },
      { title: "Equipa multidisciplinar", desc: "Ortodontista em colaboração com osteopatas, fisioterapeutas, terapeutas da fala e terapeutas oculares, permitindo uma abordagem integrada da função e postura." },
      { title: "Tecnologia 3D e IA", desc: "Planeamento digital com Inteligência Artificial — resultados mais previsíveis e confortáveis." },
    ],
    faq: [
      {
        q: "O que é condilografia e porque é importante?",
        a: "A condilografia é o registo digital dos movimentos da articulação temporomandibular (ATM). Utilizamo-la sempre que necessário para análise precisa da função articular, permitindo planear tratamentos ortodônticos que respeitam a biomecânica de cada paciente. É uma tecnologia avançada disponível em pouquíssimas clínicas em Portugal.",
      },
      {
        q: "Quando deve ser feita a primeira avaliação ortodôntica?",
        a: "O diagnóstico ortodôntico pode ser realizado precocemente, assim que a idade e colaboração do paciente o permitam. Uma avaliação atempada permite identificar situações que beneficiam de intervenção em momentos chave do desenvolvimento, frequentemente com tratamentos mais simples e conservadores.",
      },
      {
        q: "Quanto tempo demora um tratamento ortodôntico?",
        a: "Varia consoante a complexidade do caso. Em média, entre 12 e 24 meses. Casos ligeiros podem resolver-se em alguns meses; casos complexos com componente articular podem prolongar-se mais. Na primeira consulta apresentamos uma estimativa adequada ao seu caso.",
      },
    ],
    note: COMMON_BENEFITS_NOTE,
    lite: {
      en: {
        h1: "Specialised Orthodontics in Portimão",
        subtitle: "Functional and postural orthodontics in Portimão — advanced TMJ diagnosis and AI-assisted planning, for children, teens and adults.",
        benefits: [
          { icon: "Smile", title: "Harmonious smile", desc: "Aligned teeth, improved facial aesthetics and renewed confidence." },
          { icon: "Activity", title: "Protected joint function", desc: "TMJ-guided planning — less wear, less pain, less dysfunction." },
          { icon: "Compass", title: "Corrected posture", desc: "A correct occlusion has a direct impact on cervical posture and quality of life." },
        ],
      },
      de: {
        h1: "Spezialisierte Kieferorthopädie in Portimão",
        subtitle: "Funktionelle und posturale Kieferorthopädie in Portimão — fortschrittliche Kiefergelenksdiagnostik und KI-gestützte Planung, für Kinder, Jugendliche und Erwachsene.",
        benefits: [
          { icon: "Smile", title: "Harmonisches Lächeln", desc: "Gerade Zähne, verbesserte Gesichtsästhetik und neues Selbstvertrauen." },
          { icon: "Activity", title: "Geschützte Kiefergelenkfunktion", desc: "Planung anhand des Kiefergelenks — weniger Abnutzung, weniger Schmerzen, weniger Funktionsstörungen." },
          { icon: "Compass", title: "Korrigierte Körperhaltung", desc: "Eine korrekte Okklusion wirkt sich direkt auf die Halswirbelsäule und die Lebensqualität aus." },
        ],
      },
    },
  },

  estetica: {
    slug: "estetica-reabilitacao-portimao",
    seoTitle: "Estética Dentária e Reabilitação Oral em Portimão | Facetas, Coroas, Branqueamento — Instituto Clínico do Barlavento",
    seoDescription:
      "Estética dentária e reabilitação oral em Portimão com IA, scanners intraorais e faciais. Facetas, coroas, branqueamento e transformações de sorriso. Veja o seu novo sorriso antes do tratamento começar.",
    keyword: "Estética e Reabilitação Oral",
    h1: "Estética Dentária e Reabilitação Oral em Portimão",
    hero: {
      eyebrow: "Smile Design Digital com IA",
      subtitle:
        "Transforme o seu sorriso com facetas, coroas, branqueamento e reabilitações completas — desenhadas digitalmente com Inteligência Artificial. Scanners intraorais e faciais permitem-lhe ver o seu novo sorriso antes do tratamento começar.",
      image: "https://customer-assets.emergentagent.com/job_barlavento-dental/artifacts/ys02gdc3_download%20%281%29.png",
    },
    intro: {
      title: "O que é a estética dentária digital?",
      body:
        "A estética dentária moderna vai muito para além de dentes bonitos: é a arte de devolver função, harmonia e autoconfiança. No Instituto Clínico do Barlavento utilizamos scanners intraorais e faciais combinados com Inteligência Artificial para desenhar digitalmente o seu futuro sorriso — facetas, coroas, branqueamentos e reabilitações orais — permitindo-lhe visualizar o resultado antes de iniciar o tratamento. Em casos complexos de perda dentária, fazemos reabilitação oral integral devolvendo função e estética em harmonia.",
    },
    benefits: [
      { icon: "ScanFace", title: "Pré-visualização 3D", desc: "Veja o seu novo sorriso antes do tratamento começar — sem surpresas." },
      { icon: "Brain", title: "Smile Design com IA", desc: "Desenho digital assistido por Inteligência Artificial para o sorriso mais natural e harmonioso." },
      { icon: "Sparkles", title: "Resultados em poucas sessões", desc: "Facetas, coroas e branqueamento — transformações visíveis em consultas planeadas ao detalhe." },
      { icon: "Layers", title: "Reabilitação integral", desc: "Em casos complexos, devolvemos função e estética com planeamento multidisciplinar." },
    ],
    process: [
      { title: "Consulta e Análise Facial", desc: "Avaliação clínica, fotografias e análise da harmonia entre dentes, lábios e rosto." },
      { title: "Scanner Intraoral e Facial", desc: "Captura digital 3D da boca e do rosto — sem moldes desconfortáveis." },
      { title: "Smile Design com IA", desc: "Desenho digital do seu novo sorriso, com pré-visualização interativa do resultado final." },
      { title: "Fabrico CAD/CAM", desc: "Facetas e coroas em cerâmica fabricadas com precisão milimétrica em laboratórios de referência, selecionados pela sua qualidade e precisão." },
      { title: "Colocação e Acabamento", desc: "Aplicação progressiva, ajustes finos e fotografias finais. Sorriso novo, em harmonia consigo." },
    ],
    why: [
      { title: "Tecnologia Smile Design", desc: "Scanners intraorais e faciais com IA — uma das poucas clínicas no Algarve." },
      { title: "Equipa multidisciplinar", desc: "Médico dentista e prostodontista em estreita colaboração com técnicos de laboratório altamente especializados, garantindo comunicação constante e precisão nos resultados." },
      { title: "Resultados naturais", desc: "Trabalhamos a estética em harmonia com a sua face — não apenas com os dentes." },
    ],
    faq: [
      {
        q: "Posso ver o meu novo sorriso antes de começar?",
        a: "Sim — usamos scanners intraorais e faciais combinados com IA para criar uma simulação 3D do resultado final. Pode aprová-la, sugerir alterações e só depois decidir avançar com o tratamento.",
      },
      {
        q: "Quanto tempo duram as facetas e coroas?",
        a: "Com bons cuidados, as facetas e coroas em cerâmica modernas duram tipicamente 10-20 anos, podendo durar mais com manutenção adequada. Usamos materiais de alta qualidade e fabrico CAD/CAM para máxima durabilidade.",
      },
      {
        q: "Quanto custa uma transformação de sorriso?",
        a: "Depende do número de facetas/coroas, do estado inicial dos dentes e da necessidade de outros tratamentos. Na primeira consulta apresentamos uma estimativa transparente e discutimos soluções de pagamento adequadas, incluindo opções de financiamento através de entidades parceiras.",
      },
    ],
    note: COMMON_BENEFITS_NOTE,
    lite: {
      en: {
        h1: "Cosmetic Dentistry & Oral Rehabilitation in Portimão",
        subtitle: "Transform your smile with veneers, crowns and AI-powered Digital Smile Design. See your new smile before treatment begins, in the heart of Portimão.",
        benefits: [
          { icon: "ScanFace", title: "3D preview", desc: "See your new smile before treatment begins — no surprises." },
          { icon: "Brain", title: "AI-powered Smile Design", desc: "Digital design assisted by Artificial Intelligence for the most natural, harmonious smile." },
          { icon: "Sparkles", title: "Results in a few sessions", desc: "Veneers, crowns and whitening — visible transformations in carefully planned appointments." },
        ],
      },
      de: {
        h1: "Ästhetische Zahnmedizin & Mundrehabilitation in Portimão",
        subtitle: "Verwandeln Sie Ihr Lächeln mit Veneers, Kronen und KI-gestütztem Smile Design. Sehen Sie Ihr neues Lächeln, bevor die Behandlung beginnt — im Zentrum von Portimão.",
        benefits: [
          { icon: "ScanFace", title: "3D-Vorschau", desc: "Sehen Sie Ihr neues Lächeln vor Behandlungsbeginn — ohne Überraschungen." },
          { icon: "Brain", title: "KI-gestütztes Smile Design", desc: "Digitales Design mit Künstlicher Intelligenz für ein möglichst natürliches und harmonisches Lächeln." },
          { icon: "Sparkles", title: "Ergebnisse in wenigen Sitzungen", desc: "Veneers, Kronen und Bleaching — sichtbare Transformationen in präzise geplanten Sitzungen." },
        ],
      },
    },
  },
};

export const SERVICE_LANDING_LIST = Object.values(SERVICE_LANDING);
